import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useThemeMode } from '../../ThemeContext';
import ProjectsIcon from '../../assets/Projects.svg';
import TasksIcon from '../../assets/Task.svg';
import DocumentIcon from '../../assets/document-text.svg';

const StatsOverview = ({ dashboardData }) => {
  const { mode } = useThemeMode();
  const navigate = useNavigate();

  // Extract data from API response or use defaults
  const taskOverview = dashboardData?.task_overview || {};
  const projectOverview = dashboardData?.project_overview || {};
  const documentOverview = dashboardData?.document_overview || {};

  // Handle tile clicks
  const handleTileClick = (route) => {
    navigate(route);
  };

  const statsData = [
    {
      title: 'Tasks Overview',
      stats: [
        { label: 'Pending', value: taskOverview.pending_tasks || '0', color: '#26c3c0' },
        { label: 'Completed', value: taskOverview.completed_tasks || '0', color: '#26c3c0' }
      ],
      icon: TasksIcon,
      bgColor: mode === 'dark' ? '#1a4d4a' : '#e6f7f7',
      route: '/manage-task',
      clickable: true
    },
    {
      title: 'Projects Overview', 
      stats: [
        { label: 'Active', value: projectOverview.active_projects || '0', color: '#26c3c0' },
        { label: 'Completed', value: projectOverview.completed_projects || '0', color: '#26c3c0' }
      ],
      icon: ProjectsIcon,
      bgColor: mode === 'dark' ? '#1a4d4a' : '#e6f7f7',
      route: '/projects',
      clickable: true
    },
    {
      title: 'Documents Overview',
      stats: [
        { label: 'Uploaded', value: documentOverview.uploaded_documents || '0', color: '#26c3c0' },
        { label: 'Expired', value: documentOverview.expired_documents || '0', color: '#26c3c0' }
      ],
      icon: DocumentIcon,
      bgColor: mode === 'dark' ? '#1a4d4a' : '#e6f7f7',
      route: '/documents',
      clickable: true
    }
  ];

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
      gap: '20px',
      marginBottom: '30px'
    }}>
      {statsData.map((card, index) => (
        <div
          key={index}
          style={{
            backgroundColor: card.bgColor,
            borderRadius: '12px',
            padding: '24px',
            color: mode === 'dark' ? '#ffffff' : '#1a4d4a',
            minHeight: '120px',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            cursor: card.clickable ? 'pointer' : 'default',
            transition: 'opacity 0.2s ease',
            opacity: 1
          }}
          onClick={card.clickable ? () => handleTileClick(card.route) : undefined}
          onMouseEnter={card.clickable ? (e) => {
            e.target.style.opacity = '0.9';
          } : undefined}
          onMouseLeave={card.clickable ? (e) => {
            e.target.style.opacity = '1';
          } : undefined}
          title={card.clickable ? `Click to view ${card.title.toLowerCase()}` : undefined}
        >
          {/* Header */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '20px'
          }}>
            <img 
              src={card.icon} 
              alt={card.title}
              style={{ 
                width: '24px', 
                height: '24px',
                filter: mode === 'dark' ? 'brightness(0) invert(1)' : 'invert(42%) sepia(93%) saturate(1352%) hue-rotate(180deg) brightness(119%) contrast(119%)'
              }} 
            />
            <h3 style={{
              fontSize: '20px',
              fontWeight: '600',
              margin: 0,
              color: mode === 'dark' ? '#ffffff' : '#1a4d4a',
              fontFamily: 'Urbanist, Arial, sans-serif'
            }}>
              {card.title}
            </h3>
          </div>

          {/* Stats */}
          <div style={{
            display: 'flex',
            flexDirection: card.stats.length > 1 ? 'row' : 'column',
            gap: card.stats.length > 1 ? '30px' : '10px',
            flex: 1
          }}>
            {card.stats.map((stat, statIndex) => (
              <div key={statIndex} style={{
                flex: card.stats.length > 1 ? 1 : 'none'
              }}>
                <div style={{
                  fontSize: '32px',
                  fontWeight: '700',
                  color: stat.color,
                  lineHeight: '1',
                  marginBottom: '5px',
                  fontFamily: 'Urbanist, Arial, sans-serif'
                }}>
                  {stat.value}
                </div>
                <div style={{
                  fontSize: '16px',
                  fontWeight: '400',
                  color: mode === 'dark' ? 'rgba(255, 255, 255, 0.8)' : 'rgba(26, 77, 74, 0.7)',
                  fontFamily: 'Urbanist, Arial, sans-serif',
                  textShadow: 'none',
                  transform: 'none'
                }}>
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;
